module.exports = __webpack_public_path__ + "static/img/logo.69b4f781.png";